export function initBannerCountdowns() {
	const countdowns = document.querySelectorAll('.space-banner-countdown');
	const dashoffsetCssName = '--countdown-dashoffset';
	if (!countdowns.length) return;

	countdowns.forEach((countdown) => initCountdown(countdown));

	function calculateStrokeDashoffset(current, max) {
		const maxOffset = 144;
		return Math.round((maxOffset / max) * current);
	}

	function initCountdown(countdown) {
		const countdownDays = countdown.querySelector('.countdown-days');
		const countdownHours = countdown.querySelector('.countdown-hours');
		const countdownMinutes = countdown.querySelector('.countdown-minutes');
		const countdownSeconds = countdown.querySelector('.countdown-seconds');

		const endTime = countdown.dataset.countdownTime;
		if (!endTime) return;

		const targetDate = new Date(endTime).getTime();
		const interval = setInterval(function () {
			const now = new Date().getTime();
			const timeLeft = targetDate - now;
			if (timeLeft < 0) {
				clearInterval(interval);
				return;
			}

			const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
			const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

			const hoursDashoffsetCssVal = calculateStrokeDashoffset(hours, 24);
			const minutesDashoffsetCssVal = calculateStrokeDashoffset(minutes, 60);
			const secondsDashoffsetCssVal = calculateStrokeDashoffset(seconds, 60);

			if (countdownDays) countdownDays.textContent = String(days);
			if (countdownHours) countdownHours.textContent = String(hours);
			if (countdownMinutes) countdownMinutes.textContent = String(minutes);
			if (countdownSeconds) countdownSeconds.textContent = String(seconds);

			if (countdownDays && countdownDays.parentElement) countdownDays.parentElement.style.setProperty(dashoffsetCssName, `${Math.round(144 - (144 / (days + 1)))}`);
			if (countdownHours && countdownHours.parentElement) countdownHours.parentElement.style.setProperty(dashoffsetCssName, `${hoursDashoffsetCssVal}`);
			if (countdownMinutes && countdownMinutes.parentElement) countdownMinutes.parentElement.style.setProperty(dashoffsetCssName, `${minutesDashoffsetCssVal}`);
			if (countdownSeconds && countdownSeconds.parentElement) countdownSeconds.parentElement.style.setProperty(dashoffsetCssName, `${secondsDashoffsetCssVal}`);
		}, 1000);
	}
}


